/* istanbul ignore file */
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { RELEASE_GOOGLE_BUSINESS_PROFILE_PHASE_2 } from '#client/constants/experimentsFlags';

/**
 * Return the menu config for the Logo Menu Item of the current Business Entity.
 * @returns {{
 *  isGoogleBusinessProfilePhase2Released: boolean
 * }}
 */
export function useGoogleBusinessConfig() {
  // isGoogleBusinessProfilePhase2Released - Release of productize Google Business Profile phase 2
  const isGoogleBusinessProfilePhase2Released = useExperimentFlag(
    RELEASE_GOOGLE_BUSINESS_PROFILE_PHASE_2,
    false
  );

  return {
    isGoogleBusinessProfilePhase2Released
  };
}
